const error = {
  generic: {
    code: 'Erro',
    title: 'Algo deu errado',
    description:
      'Encontramos um erro inesperado ao carregar o backoffice. Recarregue a página ou tente novamente em instantes.',
    reload: 'Recarregar página',
    detailsTitle: 'Detalhes técnicos',
    fallbackMessage: 'Ocorreu um erro inesperado',
    errorCode: 'UNEXPECTED_BACKOFFICE_ERROR',
  },
  notFound: {
    code: '404',
    title: 'Caminho não encontrado',
    description:
      'Não encontramos o recurso solicitado no backoffice. Verifique o endereço ou volte para a visão principal.',
    backHome: 'Voltar para a visão principal',
    errorCode: 'BACKOFFICE_ROUTE_NOT_FOUND',
  },
}

export default error
